import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import Text from '@swf/components/Inputs/Text';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import BackButton from '@swf/components/StarsModal/components/BackButton';
import useWizardJump from '@swf/core/hooks/useWizardJump';
import type { Dispatch } from '@swf/core/store';
import { allowedLength, required } from '@swf/core/utils/validators';

import {
  TXTCLI_Enter_N0_digit_number,
  TXTCLI_Submit,
  TXTWCL_A_verification_code_has_been_s_ELL,
  TXTWCL_DidnXt_receive_the_codeX,
  TXTWCL_Re_send_code,
  TXTWCL_The_validation_code_you_have_e_ELL,
  TXTWCL_Verification_code,
  TXTWCL_Verify_later
} from './ValidateCode.messages.json';
import styles from './ValidateCode.scss';

interface Props {
  first?: boolean;
  goBack?(): void;
  showVerifyLater?: boolean;
}

const ValidateCode: React.FC<Props> = ({ first, goBack, showVerifyLater = true }) => {
  const { jumpForward } = useWizardJump();
  const { formatMessage } = useIntl();

  const { modal } = useDispatch<Dispatch>();

  const handleVerifyLater = () =>
    first ? jumpForward('#signup.signup-legal') : modal.close('/notifications/verify-code');

  return (
    <>
      {!first && <BackButton onClick={goBack} />}
      <p className={styles.paragraph}>
        <Translation {...TXTWCL_A_verification_code_has_been_s_ELL} />
      </p>
      <Text
        maxLength={6}
        id="validationCode"
        label={TXTWCL_Verification_code}
        placeholder={formatMessage(TXTCLI_Enter_N0_digit_number, { 0: 6 })}
        validators={[required(), allowedLength([6], TXTWCL_The_validation_code_you_have_e_ELL)]}
      />
      <ButtonGroup className={classNames({ [styles.firstGroup]: first })}>
        <StarsButton
          className={classNames({ [styles.submit]: first })}
          type={first ? 'submit' : 'button'}
          translation={TXTCLI_Submit}
        />
        <StarsButton variant="secondary" translation={TXTWCL_Re_send_code} />
      </ButtonGroup>
      {showVerifyLater && (
        <div className={styles.bottomText}>
          <Translation {...TXTWCL_DidnXt_receive_the_codeX} />{' '}
          <StarsLink
            className={classNames({ [styles.verifyLater]: !first })}
            onClick={handleVerifyLater}
          >
            <Translation {...TXTWCL_Verify_later} />
          </StarsLink>
        </div>
      )}
    </>
  );
};

export default ValidateCode;
